/*
 * newsbot - Content tab for filter details
 * Contains Keywords, Sources, Entities, and Authors sections
 */

import { Keywords } from "./Keywords";
import { Sources } from "./Sources";
import { Entities } from "./Entities";
import { Authors } from "./Authors";

export function Content() {
  return (
    <div className="flex flex-col w-full gap-y-4 py-2 sm:-mx-1">
      <Keywords />
      <Sources />
      <Entities />
      <Authors />
    </div>
  );
}
